document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.mySwiper');
  if (!el || typeof Swiper === 'undefined') return;

  new Swiper(el, {
    loop: true,
    autoplay: true,
    slidesPerView: 1,
    spaceBetween: 15,
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 }
    }
  });
});